module.exports = __webpack_public_path__ + "static/media/whyHumanFirstHero.66cf0c58.png";